import { render, staticRenderFns } from "./Videoconsulta.vue?vue&type=template&id=d5d1d2de"
import script from "./Videoconsulta.vue?vue&type=script&lang=js"
export * from "./Videoconsulta.vue?vue&type=script&lang=js"
import style0 from "./Videoconsulta.vue?vue&type=style&index=0&id=d5d1d2de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports